import { createSlice, createAsyncThunk, type PayloadAction } from '@reduxjs/toolkit';
import {
  getDistributorChannelsList,
  type ApiDistributorChannel,
} from '../api/distributorChannel';

interface DistributorChannelState {
  channels: ApiDistributorChannel[];
  loading: boolean;
  error: string | null;
}

const initialState: DistributorChannelState = {
  channels: [],
  loading: false,
  error: null,
};

export const fetchDistributorChannels = createAsyncThunk(
  'distributorChannel/fetchDistributorChannels',
  async (_, { rejectWithValue }) => {
    try {
      const res = await getDistributorChannelsList();
      let rawList: ApiDistributorChannel[] = [];
      if (res && Array.isArray(res.data)) {
        rawList = res.data;
      } else if (Array.isArray(res)) {
        rawList = res;
      } else if (res && typeof res === 'object' && Array.isArray((res as any).channels)) {
        rawList = (res as any).channels;
      }
      return rawList;
    } catch (err: any) {
      return rejectWithValue(err?.message || 'Failed to fetch distributor channels');
    }
  }
);

const distributorChannelSlice = createSlice({
  name: 'distributorChannel',
  initialState,
  reducers: {
    setChannels: (state, action: PayloadAction<ApiDistributorChannel[]>) => {
      state.channels = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDistributorChannels.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDistributorChannels.fulfilled, (state, action) => {
        state.loading = false;
        state.channels = action.payload;
      })
      .addCase(fetchDistributorChannels.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { setChannels } = distributorChannelSlice.actions;
export default distributorChannelSlice.reducer;
